import React            from 'react';
import { connect }      from 'react-redux';

import { isServer }     from '../../../utils';
import { Badge }        from '../../constants/Badges';
import { BadgeService } from '../../services/BadgeService';
import { GameState } from '../../models/Enums';

type RewardBadgeProps = {
    badge: Badge;
    gameState: GameState;
    dispatch?: any;
};

interface RootState {
    gameState: GameState;
}

class RewardBadgeDumb extends React.PureComponent<RewardBadgeProps> {
    componentDidMount() {
        if (!isServer) {
            if (this.props.gameState !== GameState.GAME) {
                BadgeService.updateBadgeStatus();
            }
        }
    }

    componentDidUpdate(prevProps: RewardBadgeProps) {
        if (prevProps.badge.Arena5Slug !== this.props.badge.Arena5Slug) {
            BadgeService.updateBadgeStatus();
        }
    }

    render() {
        return <Reward data-badge-target data-activity-id = {this.props.badge.ActivityId}/>;
    }
}

export const RewardBadge = connect((state: RootState) => ({
    gameState: state.gameState,
}))(RewardBadgeDumb);

const Reward = (props: any) => <div   {...props} />;
